module.exports = __webpack_public_path__ + "img/brand.70f1d9bf.png";